import { NgModule } from "@angular/core";
import { CashplusSummaryOverviewComponent } from "@modules/cashplus/ui/cashplus-summary-overview/cashplus-summary-overview.component";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	exports: [CashplusSummaryOverviewComponent],
	imports: [CoreModule],
	declarations: [CashplusSummaryOverviewComponent]
})
export class CashplusSummaryOverviewModule {}
